import React, {useEffect} from "react";
import {Terminal} from "primereact/terminal";
import {TerminalService} from "primereact/terminalservice";

export const MscTerminal = () => {
  const commandHandler = (text) => {
    let response;
    let argsIndex = text.indexOf(" ");
    let command = argsIndex !== -1 ? text.substring(0, argsIndex) : text;

    switch (command) {
      case "msc":
        response =
          "I am currently working as Chief Researcher at the Energy  Technologies, Marmara Research Center, TUBITAK, Ankara. I am also part-time lecturer at Cankaya University.";
        break;

      case "education":
        response =
          "Ph.D. : Computer Engineering, at Hacettepe University, Ankara, Türkiye, 2019" +
          " M.Sc. : Computer Engineering, at Dokuz Eylül University, İzmir, Türkiye,2011" +
          "B.Sc. : Computer Engineering, at Selçuk University, Konya, Türkiye.";
        break;

      case "research":
        response =
          "Social Network Analysis, Graph Theory, Data Mining, Software Architectures, Energy Monitoring Systems, Web-based Geographical Information Systems.";
        break;
      case "publications":
        response =
          "Latest one: 2022 D Küçük, S Buhan, T Demirci, MB Özkan, MS Çınar, E Altıntaş, .... TEKİS: TEİAŞ Elektrik Güç Kalitesi ve Şebeke İzleme Sistemi, CIGRE Güç Sistemleri Konferansı";
        break;

      case "contact":
        response = "mserkancinar@cankaya.edu.tr";
        break;

      case "clear":
        response = null;
        break;

      default:
        response = "Unknown command: " + command;
        break;
    }

    if (response) {
      TerminalService.emit("response", response);
    } else {
      TerminalService.emit("clear");
    }
  };

  useEffect(() => {
    TerminalService.on("command", commandHandler);

    return () => {
      TerminalService.off("command", commandHandler);
    };
  }, []);

  return (
    <div className='content'>
      <div className='terminal-demo'>
        <Terminal
          welcomeMessage='Welcome to MSC Console: Enter msc, education, research, publications, contact commands to display the information and clear to clear all commands'
          prompt='msc $'
        />
      </div>
    </div>
  );
};
